var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard-card',{attrs:{"title":"현재 운행 차량","value":_vm.count,"append-string":"대","icon":_vm.icon,"width":350,"height":180}})}
var staticRenderFns = []

export { render, staticRenderFns }